<template>
  <div>
    <div style="color:  #828282">
      <slot name="prefix" /> {{ displayHours }} : {{ displayMinutes }} : {{ displaySeconds }}
    </div>
  </div>
</template>

<script>
export default {
  props: {
    time:{
      type:Number,
      required:true,
    },
    dayCountDown:{
      type:Boolean,
      default:false,
    },
  },
  data() {
    return {
      displayDays: 0,
      displayHours: 0,
      displayMinutes: 0,
      displaySeconds: 0,
      loaded: false,
      expired: false
    }
  },
  computed: {
    _seconds: () => 1000,
    _minutes() {
      return this._seconds * 60
    },
    _hours() {
      return this._minutes * 60
    },
    _days() {
      return this._hours * 24
    },
    END() {
      return new Date(this.time)
    },
  },
  mounted() {
    this.showRemaining()
  },
  methods: {
    formatNum: num => (num < 10 ? '0' + num : num),
    showRemaining() {
      const TIMER = setInterval(() => {
        const NOW = new Date()
        const DISTANCE = this.END.getTime() - NOW.getTime()
        if (DISTANCE < 0) {
          clearInterval(TIMER)
          this.expired = true
          this.$emit('expired',true)
          return
        }else{
          this.$emit('expired',false)
        }
        this.$emit('input',DISTANCE);
        const DAYS = Math.floor(DISTANCE / this._days)
        const HOURS = Math.floor((DISTANCE % this._days) / this._hours)
        const MINUTES = Math.floor((DISTANCE % this._hours) / this._minutes)
        const SECONDS = Math.floor((DISTANCE % this._minutes) / this._seconds)
        this.displayMinutes = this.formatNum(MINUTES)
        this.displayHours = this.formatNum(HOURS)
        this.displayDays = this.formatNum(DAYS)
        this.displaySeconds = this.formatNum(SECONDS)
      }, 1000)
    }
  }
}
</script>
